// extracted by mini-css-extract-plugin
export default {"c-side-panel":"McqSidePanel_c-side-panel__cFKIb","c-side-panel-header":"McqSidePanel_c-side-panel-header__BT3FH","c-side-panel-body":"McqSidePanel_c-side-panel-body__0dmi8"};